/* eslint-disable no-unused-vars */

export enum ProductType {
  SPEECH_TO_TEXT = 'speech_recognition',
  TEXT_TO_SPEECH = 'text_to_speech',
  VOICE_CLONING = 'voice_clone',
}
